enum IngkaCartErrorCodeEnum {
	cartNotFound = 'CART_NOT_FOUND'
}

export default IngkaCartErrorCodeEnum;
